import React, {useRef, memo, useState} from 'react';
import Link from 'next/link';
import {MobileNumber} from '@/constants';
import logo from 'public/images/nav-bar/debut-logo.svg';
import OptimizedImage from '@/components/atoms/OptimizedImage';
import Icon from '@/components/atoms/Icon';
import MobileDrawer, {type MobileDrawerHandle} from './MobileDrawer';
import styles from './PopNavbar.module.scss';

// Server-rendered: the desktop nav is the site's primary internal-link surface,
// so it must exist in the raw HTML.
import DesktopMenu from './DesktopMenu';
import NavSearch from '../NavSearch';

const PopNavbar = () => {
    // Remembers which Services sub-panel pre-shows on hover. Local to this nav —
    // the only subtree that reads it (DesktopMenu → PopNav-menu).
    const [openIndex, setOpenIndex] = useState(-1);

    const drawerRef = useRef<MobileDrawerHandle>(null);
    const openDrawer = () => drawerRef.current?.open();

    return (
        <>
            <header className={`nav_grid ${styles.appBar}`}>
                <div className={styles.toolbar}>
                    <div className={`logo-section ${styles.logoBox}`}>
                        <Link href="/" prefetch={false} onClick={() => setOpenIndex(-1)}>
                            <OptimizedImage src={logo} alt="Debut infotech" className="debut-logo" priority={true} />
                        </Link>
                    </div>

                    <div className={styles.mobileActions}>
                        <div className={styles.searchBox}>
                            <NavSearch compact />
                        </div>

                        <Link
                            href={`https://wa.me/${MobileNumber}?text=Hi!%20I%20want%20to%20talk%20about%20your%20services%20and%20products.`}
                            target="_blank"
                            rel="nofollow noopener noreferrer"
                            aria-label="Contact us via WhatsApp"
                        >
                            <span className={styles.whatsappButton}>
                                <Icon name="WhatsApp" fontSize="inherit" className={styles.whatsappIcon} />
                            </span>
                        </Link>

                        <button
                            type="button"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={openDrawer}
                            className={`menu-bars-icon close-icon-button ${styles.menuButton}`}
                        >
                            <Icon name="Menu" fontSize="inherit" className={styles.menuIcon} />
                        </button>
                    </div>

                    {/* Shown/hidden purely by CSS breakpoint — no JS gate, so it never flashes. */}
                    <div className={`nav-wrapper ${styles.desktopNav}`}>
                        <DesktopMenu openIndex={openIndex} onSelect={setOpenIndex} />
                    </div>
                    <div className={styles.desktopSearch}>
                        <NavSearch />
                        <NavSearch compact inDesktopRow />
                    </div>

                    <div className={styles.contactBox}>
                        <Link href="/contact-us" className="menu-links" prefetch={false} aria-label="Contact Us">
                            <div className="app-bar-contact-btn-wrapper">
                                <button type="button" className={`helper-card-button animated-button ${styles.contactButton}`}>
                                    Contact Us
                                </button>
                            </div>
                        </Link>
                    </div>
                </div>
            </header>
            <MobileDrawer ref={drawerRef} />
        </>
    );
};

export default memo(PopNavbar);
